module.exports = __webpack_public_path__ + "img/20250519_MAN_V2.8162c6a7.png";